import React from "react";
import GermanyMap from "./components/GermanyMap";
import "./App.css";

function App() {
  return (
    <div className="App">
      <GermanyMap />
    </div>
  );
}

export default App;
